import PropTypes from "prop-types";
import * as React from "react";
import { messageFor } from "../../../domain/productComposer/problems";
import { Alert } from "../../../themeV2";
import css from "./sections.module.css";

const ProblemList = function ProblemList({ problems, title }) {
  return problems.length === 0 ? null : (
    <Alert severity="error" title={title}>
      <ul className={css.problemList}>
        {problems.map((problem) => (
          <li key={JSON.stringify(problem)}>{messageFor(problem)}</li>
        ))}
      </ul>
    </Alert>
  );
};

ProblemList.propTypes = {
  problems: PropTypes.arrayOf(PropTypes.shape({ code: PropTypes.string }))
    .isRequired,
  title: PropTypes.string,
};

export default ProblemList;
